import { aboutData } from "@/mocks/about";

export default function CooperationCTA() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
        <div className="rounded-2xl overflow-hidden mb-10 md:mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20abstract%20artistic%20photography%2C%20dramatic%20red%20and%20black%20gradients%20with%20golden%20accents%2C%20mysterious%20glow%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20professional%20fine%20art%20photography%2C%20luxurious%20textures%2C%20dark%20moody%20background&width=1200&height=600&seq=about-cta-img&orientation=landscape"
            alt="合作投稿"
            title="独家爆料投稿"
            className="w-full aspect-[2/1] object-cover"
          />
        </div>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
          {aboutData.ctaTitle}
        </h2>
        <p className="text-base md:text-lg text-foreground-400 italic font-light mb-4">
          {aboutData.ctaSubtitle}
        </p>
        <p className="text-sm text-foreground-500 mb-8">
          联系邮箱：
          <a
            href={`mailto:${aboutData.contactEmail}`}
            className="text-primary-400 hover:text-primary-300 underline transition-colors duration-200"
          >
            {aboutData.contactEmail}
          </a>
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={`mailto:${aboutData.contactEmail}`}
            className="whitespace-nowrap px-8 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-medium rounded-full transition-all duration-200"
          >
            {aboutData.ctaButton}
          </a>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6">
          {aboutData.socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.url}
              className="flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200"
              rel="nofollow"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={link.icon}></i>
              </span>
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}